module.exports = __webpack_public_path__ + "img/实力雄厚.0020c9b2.jpg";